import axios from "axios";
const BaseUrl = process.env.REACT_APP_URL_ENCUESTA;

export async function GuardarEncuesta(ParametroGuardar) {
  try {
    const response = await axios.post(
      BaseUrl + "GuardarEncuesta",
      ParametroGuardar
    );
    return response.data;
  } catch (err) {
    console.error(err);
  }
}
